export default [
  {
    path: '/refundrequest',
    name: 'refunds-request',
    component: () => import('@/views/refund/refundRequest.vue'),
    props: true,
    meta: {
      resource: 'Refund',
      action: 'Request',
    },
  },
  {
    path: '/refundrequest/details/:id',
    name: 'refundRequest-details',
    component: () => import('@/views/refund/refundRequestDetails.vue'),
    props: true,
    meta: {
      resource: 'Refund',
      action: 'Request',
    },
  },
  {
    path: '/myrefundqueue',
    name: 'myrefund-index',
    component: () => import('@/views/refund/myRefundQueue.vue'),
    meta: {
      resource: 'Refund',
      action: 'MyQueue',
    },
  },
  {
    path: '/refundqueue',
    name: 'refundQueue-index',
    component: () => import('@/views/refund/refundQueue.vue'),
    meta: {
      resource: 'Refund',
      action: 'Queue',
    },
  },
  {
    path: '/refundqueue/details/:id',
    name: 'refundQueue-details',
    component: () => import('@/views/refund/refundQueueDetails.vue'),
    props: true,
    meta: {
      resource: 'Refund',
      action: 'Queue',
    },
  },
  {
    path: '/myrefund',
    name: 'refunds-history',
    component: () => import('@/views/refund/myRefundHistory.vue'),
    meta: {
      resource: 'Refund',
      action: 'History',
    },
  },
  {
    path: '/refundhandler/:id',
    name: 'refund-handler',
    component: () => import('@/views/refund/handler/refundHandeler.vue'),
    props: true,
    meta: {
      resource: 'Refund',
      action: 'ApproveOrReject',
    },
  },
  {
    path: '/refundreport',
    name: 'refund-report',
    component: () => import('@/views/refund/refundReport.vue'),
    meta: {
      resource: 'Refund',
      action: 'Request',
    },
  },
]
